<template>
  <el-card :body-style="{ padding: '8px 0' }" class="mt-2" v-if="true || !hide_item">
    <div class="dayplanner-suggestion-item">
      <div class="dayplanner-suggestion-item-icon">
      </div>
      <span class="sessions-effort-text" style="cursor: pointer">{{ name }}</span>
    </div>
  </el-card>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  computed: {},
  methods: {
    onAddItem() {
      this.$emit("add", this.itemId);
    }
  },
  components: {
  }
};
</script>
